import {PropsWithChildren} from 'react';
import * as React from "react";
import classNames from "classnames";
import {WrappedTextComponent} from './WrappedTextComponent';
import {sizeCssClass} from "../lib/iconHelpers";
import {IBaseMobIconProps} from "./types";


interface IIconAsImageProps extends IBaseMobIconProps, PropsWithChildren {
    imageSrc: string;
    imageCustomWidth?: number;
    imageCustomHeight?: number;
    imgClassName?: string;
}

export const IconAsImage: React.FC<IIconAsImageProps> = ({
    imageSrc,
    imageCustomWidth,
    imageCustomHeight,
    imgClassName,
    size = "16",
    modifierSupplier,
    reverseOrder,
    title,
    children,
    attrs,
}) => {
    const imgCss = classNames("ic-img",
        imgClassName,
        {
            "__rt": reverseOrder,
        },
        sizeCssClass(size),
    );

    const width = imageCustomWidth != null ? imageCustomWidth : size;
    const height = imageCustomHeight != null ? imageCustomHeight : size;
    return (
        <span className={classNames("ic_w", modifierSupplier)} title={title} {...attrs}>
            <img src={imageSrc}
                 className={imgCss}
                 width={width}
                 height={height}
            />
            {children && (<WrappedTextComponent textComponent={children} />)}
        </span>
    );
};
